// Regional Stats

<template>
  <section class="lms3010-container">
    <div class="lms3010 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li>
          <sym-link to="/regional-performance">Regional Performance</sym-link>
        </li>
        <li><span aria-current="page">Stats</span></li>
      </Ul>

      <sym-card class="lams" headerClass="p-1 pl-2">
        <div slot="header" class="reg-stat justify-between align-items-center">
          <p class="reg-stat-title serif bold">Regional Statistics</p>
          <sym-combo
            v-model="regionId"
            :input-width="50"
            display-field="regionFullName"
            :datasource="regions"
            @changed="onRegionIdChanged"
          ></sym-combo>
        </div>
      </sym-card>

      <div class="chart-container mb-3">
        <div class="w-100 pos-relative border-main">
          <canvas id="annual-summary-chart" class="p-2"></canvas>
        </div>

        <sym-card
          class="lams-light mb-0 curved-top-0 border-main"
          headerClass="p-1 pl-2"
          bodyClass="p-1"
        >
          <div
            slot="header"
            class="reg-stat-analytics justify-between align-items-center"
          >
            <p class="reg-analytics-title serif bold text-charcoal">
              Analytics
            </p>
            <sym-combo
              v-model="yearId"
              caption="Year"
              :caption-width="14"
              :input-width="30"
              display-field="yearId"
              :datasource="detailYears"
              @changed="onYearIdChanged"
            ></sym-combo>
          </div>

          <div slot="subheader" class="p-2">
            <button
              class="warning darken-5 lg-1 w-100 mb-2 shadow-dark"
              @click="goDetails"
            >
              <span><i class="fa fa-search fa-lg mr-1"></i> View Details </span
              ><i class="fa fa-chevron-right"></i>
            </button>
          </div>

          <div class="d-flex justify-center">
            <transition name="fade">
              <img
                :src="getImagePath()"
                :key="regionId"
                alt="Region map"
                class="region-map pos-absolute w-65 d-block fade-in curved-2"
                @click="goDetails"
                v-if="regionId"
                title="View detailed statistics for this region"
              />
            </transition>
          </div>
        </sym-card>
      </div>

      <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-2 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div>
  </section>
</template>

<script>
import { get } from "../../js/http";

import * as lams from "../../js/lams";

import { drawLineChart } from "../../js/graph";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms3010",

  data() {
    return {
      regionId: 0,
      regionName: "Unknown",
      regions: [],
      charts: [],

      yearId: this.core.getCurrentYear(),
      detailYears: [],

      summaryYears: [],
      submittedCounts: [],
      approvedCounts: [],
      pendingCounts: [],
      cancelledCounts: [],
      rejectedCounts: [],
    };
  },

  methods: {
    getTargetPath() {
      const me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;

      me.regionName = "Unknown";

      if ("regionId" in q) {
        me.regionId = parseInt(q.regionId);
        let region = me.regions.find((obj) => obj.regionId === me.regionId);
        if (region) {
          me.regionName = region.regionFullName;
        }
      } else {
        me.regionId = 0;
      }
    },

    loadData() {
      const me = this;

      me.getAnnualStats().then(
        (data) => {
          // annual summary
          me.summaryYears = data.map((o) => o.yearId);
          me.submittedCounts = data.map((o) => o.submittedCount);
          me.approvedCounts = data.map((o) => o.approvedCount);
          me.rejectedCounts = data.map((o) => o.rejectedCount);
          me.pendingCounts = data.map((o) => o.pendingCount);
          me.cancelledCounts = data.map((o) => o.cancelledCount);
          me.residualCounts = data.map((o) => o.residualCount);
          me.inProcessCounts = data.map((o) => o.inProcessCurrentCount);

          me.drawCharts();
        },
        (fault) => {
          me.showFault(fault);
        }
      );
    },

    // API Calls

    getAnnualStats() {
      let me = this,
        // query = "regionId=" + me.regionId.toString();
        query =
          "regionId=" +
          me.regionId.toString() +
          "&yearId=" +
          me.yearId.toString();

      return get("api/stats/region-annual?" + query);

      // return get("api/stats/regions-pla/year/2023?" + query);
    },

    // event handlers

    onRegionIdChanged() {
      this.reload();
    },

    onYearIdChanged() {
      this.goDetails();
    },

    // helpers

    getImagePath() {
      let fileName = "region-" + this.regionId + ".jpg";
      // return `${require(`../../img/fig/${fileName}`)}`;
      // public folder
      return `img/fig/${fileName}`;
    },

    goDetails() {
      let route = {
        name: "lms3020",
        query: {
          regionId: this.regionId,
          yearId: this.yearId,
        },
      };
      this.go(route);
    },

    drawSummaryChart() {
      const me = this;

      let chartData = {
        labels: me.summaryYears,

        datasets: [
          {
            label: "Submitted",
            data: me.submittedCounts,
            // backgroundColor: "#fbbe0b", //"#3cba9f",
            backgroundColor: "rgb(251, 190, 11 , .4)",
            borderColor: "#fbbe0b",
            borderWidth: 2,
            //  pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",

            fill: true,
            opacity: 0.2,
            tension: 0.6,
          },

          {
            label: "Approved",
            data: me.approvedCounts,
            // backgroundColor: "#507cc4",
            backgroundColor: "rgb(80, 124, 196, .4)",
            borderColor: "#507cc4",
            borderWidth: 2,
            //       // pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",
            fill: true,
            tension: 0.6,
          },

          // {
          //   label: "Pending",
          //   data: me.pendingCounts,
          //   backgroundColor: "#c49d50",
          // },

          {
            label: "Rejected",
            data: me.rejectedCounts,
            // backgroundColor: "#c45850",
            backgroundColor: "rgb(196, 88, 80, .4)",
            borderColor: "#c45850",
            borderWidth: 2,
            //       // pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",
            fill: true,
            tension: 0.6,
          },

          {
            label: "In-Process",
            data: me.inProcessCounts,
            // backgroundColor: "#5A9367",
            backgroundColor: "rgb(90, 147, 103, .4)",
            borderColor: "#5A9367",
            borderWidth: 2,
            //       // pointBackgroundColor: '#28a745',
            pointBackgroundColor: "#fefefe",
            fill: true,
            tension: 0.6,
          },

          // {
          //   label: "Residual",
          //   data: me.residualCounts,
          //   // backgroundColor: "violet", //"#c45850",
          //   backgroundColor: "rgb(127, 0, 255, .4)",
          //   borderColor: "7F00FF",
          //   borderWidth: 2,
          //   //       // pointBackgroundColor: '#28a745',
          //   pointBackgroundColor: "#fefefe",

          //   // fill: true,
          //   tension: 0.6,
          // },

          // {
          //   label: "Cancelled",
          //   data: me.cancelledCounts,
          //   backgroundColor: "#c45850",
          // },
        ],
        // let chartData = {
        //   labels: me.summaryYears,
        //   datasets: [
        //     {
        //       label: "Submitted",
        //       data: me.submittedCounts,
        //       backgroundColor: "rgb(60, 186, 159, 0.2)",

        //       borderColor: "#28a745",
        //       borderWidth: 2,
        //       // pointBackgroundColor: '#28a745',
        //       pointBackgroundColor: "#fefefe",

        //       fill: true,
        //       tension: 0.6,
        //     },

        //     {
        //       label: "Approved",
        //       data: me.approvedCounts,
        //       backgroundColor: "rgb(31.4, 48.6, 76.9,0.2)",

        //       borderColor: "#507cc4",
        //       borderWidth: 2,
        //       // pointBackgroundColor: '#28a745',
        //       pointBackgroundColor: "#fefefe",

        //       fill: true,
        //       tension: 0.6,
        //     },

        //     {
        //       label: "Pending",
        //       data: me.pendingCounts,
        //       backgroundColor: "rgb(76.9, 61.6, 31.4, 0.2)",

        //       borderColor: "#c49d50",
        //       borderWidth: 2,
        //       // pointBackgroundColor: '#28a745',
        //       pointBackgroundColor: "#fefefe",

        //       fill: true,
        //       tension: 0.6,
        //     },

        //     // {
        //     //   label: 'Rejected',
        //     //   data: me.rejectedCounts,
        //     //   backgroundColor: 'rgb(776.9, 34.5, 31.4, 0.2)',

        //     //   borderColor: '#c45850',
        //     //   borderWidth: 2,
        //     //   // pointBackgroundColor: '#28a745',
        //     //   pointBackgroundColor: '#fefefe',

        //     //   fill: true,
        //     //   tension: 0.6
        //     // }

        //     {
        //       label: "Cancelled",
        //       data: me.cancelledCounts,
        //       backgroundColor: "rgb(776.9, 34.5, 31.4, 0.2)",

        //       borderColor: "#c45850",
        //       borderWidth: 2,
        //       // pointBackgroundColor: '#28a745',
        //       pointBackgroundColor: "#fefefe",

        //       fill: true,
        //       tension: 0.6,
        //     },
        //   ],
      };

      let options = {
        scales: {
          y: {
            beginAtZero: true,
          },
        },

        plugins: {
          title: {
            display: true,
            text: " Transaction Status",
            font: {
              size: 19,
              lineHeight: 1,
            },
            padding: {
              top: 10,
            },
          },

          legend: {
            labels: {
              boxWidth: 20,
            },
          },
        },

        aspectRatio: 1.4,
      };

      let chart = drawLineChart("annual-summary-chart", chartData, options);
      this.charts.push(chart);
    },

    drawCharts() {
      this.charts.forEach((chart) => {
        chart.destroy();
        chart = null;
      });

      this.drawSummaryChart();
    },
  },

  mounted() {
    const me = this;

    me.dom.on(window, "resize", me.drawCharts);

    me.regions = lams.getRegionList();
    me.detailYears = lams.getYearsDatasource();

    me.syncValues(me.params, me.query);
    me.loadData();
  },

  beforeDestroy() {
    this.dom.off(window, "resize", this.drawCharts);
  },

  beforeRouteUpdate(to, from, next) {
    this.syncValues(to.params, to.query);
    next();

    if (Object.keys(from.query).length) {
      this.loadData();
    }
  },
};
</script>

<style scoped>
.lms3010-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms3010 {
  width: 80%;
  padding: 1rem 2rem;
  border-radius: 0.375rem;
}

.reg-stat-title,
.reg-analytics-title {
  font-size: 1.125rem;
  margin-bottom: 0;
  padding-left: 0.125rem;
}

.reg-stat,
.reg-stat-analytics {
  display: flex;
}

.reg-stat >>> .form-control,
.reg-stat-analytics >>> .form-control {
  margin-bottom: 0;
}

.chart-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  grid-auto-flow: dense;
}

.region-map:hover {
  cursor: pointer;
}

@media (max-width: 1024px) {
  .lms3010 {
    width: 90%;
    padding: 2rem;
  }
}

@media (max-width: 960px) {
  .lms3010-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms3010 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }

  .reg-stat {
    display: block;
  }

  .reg-stat-title,
  .reg-analytics-title {
    font-size: 1rem;
  }

  .reg-stat-title {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .chart-container {
    display: block;
  }

  .region-map {
    display: none !important;
  }
}

@media (max-width: 420px) {
  .lms3010 {
    padding: 0.5rem;
  }
}
</style>
